import { useMemo } from 'react';

import Select from 'components/shared/Select/Select';
import Typography from 'components/shared/Typography/Typography';

const IncomeIQueueStepRow = ({ label, value, options, onChange, dataQa }) => {
  const selectedOption = useMemo(
    () => options.find((option) => option.value === value) || null,
    [options, value]
  );

  return (
    <div
      className="flex items-center gap-3 rounded-md border border-solid border-neutral-200 bg-neutral-50 px-3 py-[6px]"
      data-qa={dataQa}>
      <Typography size="small" color="neutral-900">
        {label}
      </Typography>
      <Select
        inputId={dataQa}
        value={selectedOption}
        options={options}
        isClearable={false}
        onChange={(option) => onChange(option?.value)}
        styles={{ container: { width: 'fit-content' } }}
      />
    </div>
  );
};

export default IncomeIQueueStepRow;
